import { ActionStatus, FACTION_NAMES, Room } from '../../../Constants';
import {
    angryDocks,
    clockedInTempStaff,
    clockOutableStaff, ghostCount, ghostedDocks,
} from '../../Game/GamePlayerInfo';


function doIhaveFate(gamePlayerController, aiPackage) {
    const currentFate = gamePlayerController.gamePlayerData.current_fate;
    const result = currentFate > 0;
    const question = 'What about Fate?'
    let reason = 'There is no Fate but what we make'
    if (result) {
        reason = `I have Fate (${currentFate}), Now I must Act.`;
        aiPackage.complete = false;
    } else {
        aiPackage.addToMessage('There is no Fate but what we make');
        aiPackage.complete = true;
        // This is the Ghost action — close it out with ghostJuice, not
        // lodgingJuice (copy-paste from AILodging). Firing the wrong
        // juicer here sent a mismatched package into the Ghost flow.
        if (aiPackage.execute) gamePlayerController.gamePlayerApi.ghostJuice([]);
    }
    aiPackage.addProvenance(question, result, reason);
    return result;
}

function shouldIJuiceGhosting(gamePlayerController, aiPackage) {
    // attack or build matters....
    // I want 2, 3, 4, 5, 6, 7, 8;
    let available = clockOutableStaff(gamePlayerController.gamePlayerData);
    let result = available.length > 0
    let question = 'Do I have available staff for Clock-Out?'
    let reason = 'There are none available.'
    if (result) {
        reason = `There are ${available.length} available.`;
    }
    aiPackage.addProvenance(question, result, reason);
    if (!result) return false;

    let want = 2;
    const current = clockedInTempStaff(gamePlayerController.gamePlayerData).length;
    result = current > want
    question = 'Clock-Out Available Staff to Juice?'
    reason = `I want ${want} and I have ${current}.`;
    aiPackage.addProvenance(question, result, reason);
    return result;
}


function shouldIAttackWithGhosts(gamePlayerController, aiPackage) {
    // todo: glean condition from config
    const question = 'Should I Attack?'
    const reason = `As to not waste an action.`;
    aiPackage.addProvenance(question, true, reason);
    return true;
}


function shouldIRemoveGhosts(gamePlayerController, aiPackage) {
    // todo: glean condition from config
    let question = `Are there Angry Ghosts? `;
    let answer = false;
    let reason = 'Angry Ghosts cost Snohe every round.'
    const angry = angryDocks(gamePlayerController.gamePlayerData);
    if (angry.length > 0) {
        answer = true;
    }
    aiPackage.addProvenance(question, answer, reason);
    if (!answer) {
        question = `Are there Any Ghosts? `;
        answer = false;
        reason = 'Clean docks are superior to Ghosted ones.'
        let docks = ghostedDocks(gamePlayerController.gamePlayerData);
        if (docks.length > 0) {
            answer = true;
        }
        aiPackage.addProvenance(question, answer, reason);
    }
    return answer;
}

function setJuice(gamePlayerController, aiPackage) {
    let clockedOutStaff = [];
    const staffMember = clockOutableStaff(gamePlayerController.gamePlayerData).pop();
    clockedOutStaff.push(staffMember);
    aiPackage.clockedOutStaff = clockedOutStaff
    aiPackage.addToMessage(`Clock Out Staff #${staffMember}`);
}

function attackTarget(gamePlayerController, aiPackage) {
    let message = '';
    let target = null;
    let orderedPlayers = [ ...gamePlayerController.gameData.gameplayer_set ].filter(
        player => player.id !== gamePlayerController.gamePlayerData.id);
    orderedPlayers.sort((a, b) => a.current_score - b.current_score);
    while (orderedPlayers.length > 0) {
        target = orderedPlayers.pop();
        if (ghostCount(target) < 8) {
            message = `Target -> ${target.name}-${target.seat}`;
            aiPackage.addToMessage(message);
            aiPackage.complete = true;
            const question = 'Who has the highest score and is not full?'
            const answer = `${target.name}-${target.seat}`;
            aiPackage.addProvenance(question, answer, 'Seek the strongest.');
        }
    }

    if (!target) {
        aiPackage.addToMessage('No suitable target, Skip');
    }

    if (aiPackage.execute && target) {
        gamePlayerController.gamePlayerApi.ghostFullAction(
            aiPackage.clockedOutStaff,
            target.id,
            null
        )
    } else if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickNext();
    }
}


function aiRemoveGhost(gamePlayerController, aiPackage) {
    let question = `Are there Angry Ghosts? `;
    let answer = false;
    let reason = 'Start with Angry Ghosts first.'
    let dock = null;
    const angry = angryDocks(gamePlayerController.gamePlayerData);
    if (angry.length > 0) {
        dock = angry.pop();
        answer = true;
        aiPackage.addToMessage('Remove Angry Ghost');
    }
    aiPackage.addProvenance(question, answer, reason);

    if (!answer) {
        question = `Are there Any Ghosts? `;
        answer = false;
        reason = 'Start with Dock 0 and Clean.'
        let docks = ghostedDocks(gamePlayerController.gamePlayerData);
        if (docks.length > 0) {
            dock = docks.pop();
            answer = true;
            aiPackage.addToMessage(`Remove Satisfied Ghost from Dock ${dock}`);
        }
        aiPackage.addProvenance(question, answer, reason);
    }

    aiPackage.complete = true;
    aiPackage.success = true;
    if (dock !== null && aiPackage.execute) {
        gamePlayerController.gamePlayerApi.ghostFullAction(
            aiPackage.clockedOutStaff,
            gamePlayerController.gamePlayerData.id,
            dock,
        )
    } else if (dock == null && aiPackage.execute) {
        // No ghost on any dock in the current snapshot. At REMOVE_ID the
        // engine GUARANTEES one is present — prompt_to_remove_ghosts calls
        // done() the instant ghosted_docks empties — so a null dock here is a
        // STALE re-drive (the empowered no-progress fallback / a head-rotated
        // re-invite firing on an older gamePlayerData: the G147 [ActionChain]
        // Mismatch clicks, 2026-07-14). clickNext() is an ILLEGAL move at
        // REMOVE_ID: a dockless Next click routes into deghost_docks, which
        // reads .data.dock and crashed the whole Celery worker (no Reject, no
        // patch — seat stranded). There is no legal "skip removal" click; the
        // only legal move is a dock, and this snapshot has none. Suppress the
        // click — the authoritative REMOVE prompt (carrying the live ghost)
        // drives the real removal. Everywhere else aiRemoveGhost runs
        // (WAIT_FOR_JUICE self-target, gated behind shouldIRemoveGhosts) the
        // legacy decline is preserved.
        if (gamePlayerController.gamePlayerData.action_status
                === ActionStatus.REMOVE_ID) {
            aiPackage.addToMessage(
                'REMOVE: no ghosted dock in view (stale re-drive); '
                + 'suppressing illegal dockless click.');
        } else {
            gamePlayerController.gamePlayerApi.clickNext();
        }
    }
}


function pickGhostOpponent(gamePlayerController, aiPackage) {
    // Same shape as attackTarget's selection block — highest-score
    // opponent below the ghost-cap — but returns the target object
    // instead of firing a spend. Used by both the pre-roll INIT
    // target commit and the post-roll WAIT_FOR_JUICE spend.
    let orderedPlayers = [...gamePlayerController.gameData.gameplayer_set]
        .filter(player => player.id !== gamePlayerController.gamePlayerData.id);
    orderedPlayers.sort((a, b) => a.current_score - b.current_score);
    while (orderedPlayers.length > 0) {
        const candidate = orderedPlayers.pop();
        if (ghostCount(candidate) < 8) {
            aiPackage.addProvenance(
                'Who has the highest score and is not full?',
                `${candidate.name}-${candidate.seat}`,
                'Seek the strongest.');
            return candidate;
        }
    }
    return null;
}


function aiGhostCommitTarget(gamePlayerController, aiPackage) {
    // Manual §7.2.6 pre-roll target commit. current_fate is zero at
    // INIT — we cannot peek at it. Decision rule: if any ghosts on
    // own docks (would cleanse post-roll), target = self; else
    // target = opponent (via attack selection); fall back to self if
    // no viable opponent.
    let target_id = null;
    const my_id = gamePlayerController.gamePlayerData.id;
    // No `current_action_target` early-return (verbatim mirror of the Lodging
    // twin's removal). This handler runs ONLY at INIT_ID / WAIT_FOR_TARGET_ID,
    // where the SERVER's current_action_target is None by the state machine —
    // a committed target means the engine already rolled to WAIT_FOR_JUICE,
    // which the switch routes elsewhere. Any non-null current_action_target
    // seen here is STALE FE data. The old guard treated it as "already
    // committed" and returned in SILENCE, parking the seat forever on the
    // target picker (G117, 2026-07-12: reload did nothing; a MANUAL target
    // click unlocked it — the commit the engine was waiting for). Fix: ignore
    // the stale value and commit a fresh target below. Same-patch double-fire
    // is owned by the (action_status, chain head) commitLatch just below.
    // Always-act: HSH_STYLE §AI always-act ("a silent return is the only
    // illegal move").
    // CC_LODGING_COMMIT_SINGLE_DISPATCH: identical re-fire to the Lodging
    // twin (ghost_action.commit_target is a verbatim mirror of
    // lodging_action.commit_target). The own-seat auto driver can re-run this
    // handler for the SAME pre-roll action more than once before the commit
    // round-trips — the concur re-fire on one patch, and (G127, 2026-07-12)
    // the empowered no-progress fallback re-driving the seat on a later
    // broadcast. Any duplicate ghostCommitTarget that lands after the first
    // has advanced the engine to WAIT_FOR_JUICE trips the stale_target_commit
    // Reject and pushes the seat toward belay/freeze. One commit per pre-roll
    // opportunity fences it.
    // Key the latch on action_status ALONE (the commit phase — INIT_ID or
    // WAIT_FOR_TARGET_ID), NOT on current_action. current_action is NOT in the
    // GamePlayer serializer (games/serializers.py never lists it), so live
    // gamePlayerData.current_action is ALWAYS undefined and the old
    // `${action_status}:${current_action}` key evaluated to null on EVERY eval
    // — the fence was DEAD CODE in production and only ever fenced in tests
    // that injected a fictional current_action (the client-contract hollow-
    // green trap, HSH_STYLE §Protocol Changes). With the fence inert, the
    // empowered no-progress fallback (CC_FEAI_ROBOTING_REDRIVE_STALL) re-drove
    // this handler at INIT after the first commit had already rolled the seat
    // to WAIT_FOR_JUICE, landing a bare player_target click there and firing
    // the user-facing stale_target_commit Reject (verbatim mirror of the
    // Lodging twin, prod G136, 2026-07-13). action_status IS serialized, so
    // keying on it makes the fence actually fire live; it is stable across the
    // head-rotating re-drives of ONE commit opportunity (the head is
    // deliberately NOT in the key — head-keying was the older G127 bug), and
    // the reset at the top of artificialGhostAction (fired once the seat leaves
    // the commit phase) distinguishes THIS opportunity from a later Ghost
    // action in the same turn. INIT and the WAIT_FOR_TARGET_ID re-prompt
    // (ghost_action.commit_target flips INIT -> WAIT_FOR_TARGET_ID when the
    // entry carries no player_target — the seat otherwise stalled at
    // WAIT_FOR_TARGET_ID forever, G106, 2026-07-11) keep their own keys so each
    // commits once.
    const actionStatus = gamePlayerController.gamePlayerData.action_status;
    const commitLatch = (actionStatus !== null && actionStatus !== undefined)
        ? `commit:${actionStatus}`
        : null;
    if (commitLatch !== null
            && gamePlayerController._ghostCommitUuid === commitLatch) {
        aiPackage.addToMessage(
            'Ghost target commit already emitted this patch; '
            + 'skipping duplicate.');
        aiPackage.complete = true;
        aiPackage.success = true;
        return aiPackage;
    }
    if (shouldIRemoveGhosts(gamePlayerController, aiPackage)) {
        target_id = my_id;
        aiPackage.addToMessage('Pre-roll Target -> Self (cleanse ghosts)');
    } else {
        const opponent = pickGhostOpponent(
            gamePlayerController, aiPackage);
        if (opponent) {
            target_id = opponent.id;
            aiPackage.addToMessage(
                `Pre-roll Target -> ${opponent.name}-${opponent.seat}`);
        } else {
            target_id = my_id;
            aiPackage.addToMessage(
                'Pre-roll Target -> Self (no opponent available)');
        }
    }
    aiPackage.complete = true;
    aiPackage.success = true;
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.ghostCommitTarget(target_id);
        // CC_LODGING_COMMIT_SINGLE_DISPATCH: stamp the action_status latch so
        // any re-drive of this same pre-roll opportunity is fenced above. Only
        // stamp a real status — a null/undefined action_status can't fence and
        // must never strand a later commit.
        if (commitLatch !== null) {
            gamePlayerController._ghostCommitUuid = commitLatch;
        }
    }
    return aiPackage;
}


function attackSpendOnCommittedGhostTarget(gamePlayerController, aiPackage) {
    // Target was already committed pre-roll; we just spend staff
    // here. Send a Juice click with sold_robots; backend reads target
    // off current_action_target and routes to apply_attack.
    aiPackage.addToMessage('Spend ghosts on committed opponent target');
    aiPackage.complete = true;
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.ghostJuice(
            aiPackage.clockedOutStaff || []);
    }
}


function aiGhostActionWaitForJuice(gamePlayerController, aiPackage) {
    // Target is already persisted on current_action_target (committed
    // at INIT). This phase makes the juice (clock-out) decision and
    // dispatches spend against the committed target — no
    // target-picking here.

    doIhaveFate(gamePlayerController, aiPackage);

    if (!aiPackage.complete && shouldIJuiceGhosting(gamePlayerController, aiPackage)) {
        setJuice(gamePlayerController, aiPackage);
    }

    const target_id = gamePlayerController.gamePlayerData.current_action_target;
    const my_id = gamePlayerController.gamePlayerData.id;
    if (target_id === my_id) {
        if (!aiPackage.complete && shouldIRemoveGhosts(
                gamePlayerController, aiPackage)) {
            aiRemoveGhost(gamePlayerController, aiPackage);
        }
    } else if (target_id !== null && target_id !== undefined) {
        attackSpendOnCommittedGhostTarget(gamePlayerController, aiPackage);
    } else {
        // Defensive: no target committed. Fall back to legacy in-step
        // decision (should not occur after CC_FATE_ORDER_FRONTEND).
        if (!aiPackage.complete && shouldIRemoveGhosts(
                gamePlayerController, aiPackage)) {
            aiRemoveGhost(gamePlayerController, aiPackage);
        }
        if (!aiPackage.complete && shouldIAttackWithGhosts(
                gamePlayerController, aiPackage)) {
            attackTarget(gamePlayerController, aiPackage);
        }
    }

    aiPackage.success = true;
    return aiPackage;
}


export default function artificialGhostAction(gamePlayerController, aiPackage) {
    // Reset the pre-roll commit latch once the seat leaves the commit phase.
    // The latch keys on action_status alone, which is identical (INIT_ID) for
    // every Ghost action's commit phase in a turn — so this reset is what
    // distinguishes THIS pre-roll opportunity from a fresh Ghost action later
    // in the turn. The engine always pauses at WAIT_FOR_JUICE, so clearing
    // whenever action_status is not a commit-phase status lets the next Ghost
    // action commit while still fencing head-rotated re-drives within one
    // action's INIT / WAIT_FOR_TARGET window. Verbatim mirror of
    // artificialLodgingAction.
    const resetStatus = gamePlayerController.gamePlayerData.action_status;
    if (resetStatus !== ActionStatus.INIT_ID
            && resetStatus !== ActionStatus.WAIT_FOR_TARGET_ID) {
        gamePlayerController._ghostCommitUuid = null;
    }

    switch (gamePlayerController.gamePlayerData.action_status) {
    case ActionStatus.INIT_ID:
        aiGhostCommitTarget(gamePlayerController, aiPackage);
        return aiPackage;
    case ActionStatus.WAIT_FOR_TARGET_ID:
        aiGhostCommitTarget(gamePlayerController, aiPackage);
        return aiPackage;
    case ActionStatus.WAIT_ID:
        aiPackage.addToMessage('Ghost Confirm');
        gamePlayerController.confirmGhostAction();
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.FATE_MINIGAME_ID:
        aiPackage.addToMessage('Ghost Fate Choice');
        gamePlayerController.ghostFateMinigameChoice();
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.FATE_MINIGAME_DONE_ID:
        aiPackage.addToMessage('Ghost Fate Response');
        gamePlayerController.ghostFateMinigameDone();
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.WAIT_FOR_JUICE:
        aiGhostActionWaitForJuice(gamePlayerController, aiPackage);
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.JUICE_ID:
        aiPackage.addToMessage('Ghost Status Juice not supported');
        return aiPackage;
    case ActionStatus.REMOVE_ID:
        aiRemoveGhost(gamePlayerController, aiPackage);
        return aiPackage;
    case ActionStatus.ATTACKING_ID:
        aiPackage.addToMessage('Ghost Attack Underway');
        aiPackage.success = true;
        return aiPackage;
    case ActionStatus.DONE_ID:
        aiPackage.addToMessage('Ghost Done Confirmation');
        aiPackage.success = true;
        return aiPackage;
    default:
        console.error('Ghost Too Far.', gamePlayerController.gamePlayerData.action_status);
        break;
    }
}
